// extracted by mini-css-extract-plugin
export default {"container":"terms_container__g3qZI","item":"terms_item__C0MMl","subitem":"terms_subitem__Nkkvi","date":"terms_date__IjQM4"};